import { Box } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import { ParceirosParametrosHeader } from './ParceirosParametrosHeader';
import TableHeader from '../../../../../theme/components/TableHeader/TableHeader';
import { ParceirosParametrosFilters } from './ParceirosParametrosFilters';

export const ParceirosParametros = props => {
  const { handleDownloadInvoices, filters, setFilters, setSelectedFilter, parcelasFilter, setParcelasFilter } = props;

  return (
    <Box mb={2}>
      <TableHeader>
        <ParceirosParametrosHeader
          handleDownloadInvoices={handleDownloadInvoices}
          filters={filters}
          setFilters={setFilters}
          setParcelasFilter={setParcelasFilter}
          parcelasFilter={parcelasFilter}
        />
        <ParceirosParametrosFilters
          filters={filters}
          setFilters={setFilters}
          setSelectedFilter={setSelectedFilter}
          parcelasFilter={parcelasFilter}
          setParcelasFilter={setParcelasFilter}
        />
      </TableHeader>
    </Box>
  );
};

ParceirosParametros.propTypes = {
  handleDownloadInvoices: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    partner: PropTypes.string,
    status: PropTypes.string,
    referenceDate: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  setSelectedFilter: PropTypes.func.isRequired,
  parcelasFilter: PropTypes.string.isRequired,
  setParcelasFilter: PropTypes.func.isRequired,
};
